import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

const Logout: React.FC = () => {
  const navigate = useNavigate();
  const destroySession = useAuthStore((state) => state.destroySession);

  useEffect(() => {
    const handleLogout = async () => {
      await destroySession();
      navigate('/login');
    };
    handleLogout();
  }, [destroySession, navigate]);

  return <div>Déconnexion...</div>;
};

export default Logout;

